<template>
  <div class="section-category section-bg">
    <div class="inner-note">
      <h3 v-translate>Note</h3>
      <div class="text-center pb-3">
        <button v-for="(option, i) in getSelectedItemCookingOptions" :key="i"
          class="btn btn-sm btn-outline-dark m-1"
          @click="setNote(option)">
          {{ option }}
        </button>
      </div>
      <textarea class="form-control" rows="2" autofocus v-model="note"></textarea>
      <button class="btn btn-primary" @click="onConfirm" v-translate>Ok</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AddNote',
  data() {
    return {
      note: '',
    };
  },
  computed: {
    selectedItem: {
      get() { return this.getMap('selectedItem', true) },
      set(value) { this.$store.state.bill.selectedItem }
    },
    ...mapGetters(['getSelectedItemCookingOptions']),
  },
  methods: {
    setNote(value) {
      this.note = value;
    },
    onConfirm() {
      this.selectedItem.note = this.note;
      this.selectedItem = null;
      this.$router.replace({ name: 'order' });
    },
  },
};
</script>
